export const template_a3 = (yb, ye, mb, me, sl, su, tl, tu, kf, o, kr, d, target) =>({
    "inputs":[
      {
          "id":"yb",
          "input":{
             "format":{
                "mimeType":"text/plain"
             },
             "value":{
                "inlineValue": yb
             }
          }
       },
       {
         "id":"ye",
         "input":{
            "format":{
               "mimeType":"text/plain"
            },
            "value":{
               "inlineValue": ye
            }
         }
      },
      {
          "id":"mb",
          "input":{
             "format":{
                "mimeType":"text/plain"
             },
             "value":{
                "inlineValue": mb
             }
          }
       },
      {
          "id":"me",
          "input":{
             "format":{
                "mimeType":"text/plain"
             },
             "value":{
                "inlineValue": me
             }
          }
       },
      {
          "id":"sl",
          "input":{
             "format":{
                "mimeType":"text/plain"
             },
             "value":{
                "inlineValue": sl
             }
          }
       },
       {
        "id":"su",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": su
           }
        }
     },
     {
        "id":"tl",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": tl
           }
        }
     },
     {
        "id":"tu",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": tu
           }
        }
     },
     {
        "id":"kf",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": kf
           }
        }
     },
     {
        "id":"o",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": o
           }
        }
     },
     {
        "id":"kr",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": kr
           }
        }
     },
     {
        "id":"d",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": d
           }
        }
     },
     {
        "id":"token",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": "5267228188:AAGx60FtWgHkScBb3ISFL1dp6Oq_9z9z0rw"
           }
        }
     },
     {
        "id":"chat_id",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": "-1001773490347"
           }
        }
     },
     {
        "id":"bulletin",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": "./output/bulletin.png "
           }
        }
     },
     {
        "id":"method",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": "file"
           }
        }
     },  
     {
        "id":"Wbb",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": target.substr(2, 12)
           }
        }
     },
     {
        "id":"Ebb",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": target.substr(31, 12)
           }
        }
     },
     {
        "id":"Sbb",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": target.substr(15, 12)
           }
        }
     },
     {
        "id":"Nbb",
        "input":{
           "format":{
              "mimeType":"text/plain"
           },
           "value":{
              "inlineValue": target.substr(73, 12)
           }
        }
     },
    ],
    "outputs":[
       {
          "id":"result",
          "format":{
             "mimeType":"application/binary"
          },
          "transmissionMode":"reference"
       }
    ],
    "response":"document",
    "mode":"async"
 })